<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-content>
    <v-form
      ref="queryForm"

    >
      <v-row
        align="center"
      >


        <v-col
          cols="2"
          xs="4"
        >
          <v-text-field
            clearable
            v-model="queryData.menuName"
            label="名称"
            single-line
          ></v-text-field>
        </v-col>

        <v-col
          cols="2"
          xs="4"
        >
          <v-text-field
            clearable
            v-model="queryData.path"
            label="路径"
            single-line
          ></v-text-field>
        </v-col>

        <v-col
          cols="2"
          xs="4"
        >
          <v-btn

            :loading="loading.queryRequest"
            @click="handleQuery"
          >
            搜索
            <v-icon right>mdi-magnify</v-icon>
          </v-btn>
          <v-btn

            class="ma-2"
            @click="resetQuery"
          >
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </v-col>

      </v-row>
    </v-form>
    <v-row>
      <v-data-table
        :headers="dataTable.headers"
        :items="dataTable.list"
        :options.sync="dataTable.options"
        :server-items-length="dataTable.total"
        :loading="loading.queryRequest"
      >
        <template v-slot:top>
          <v-toolbar height="40" flat>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog.add" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn small v-on="on">添加
                  <v-icon small>mdi-plus</v-icon>
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">角色添加</span>
                </v-card-title>

                <v-card-text>
                  <v-container>

                    <v-form ref="addForm" v-model="formValid.add"  >

                      <v-row align="center">
                        <v-col cols="6">
                          <v-text-field  v-model="addData.menuName" label="菜单名称" :rules="[v => !!v || '菜单名称为必输项']" ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row align="center">
                        <v-col cols="6">
                          <v-text-field  v-model="addData.path" label="路径" :rules="[v => !!v || '路径为必输项']" ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row align="center">
                        <v-col cols="6">
                          <v-text-field  v-model="addData.component" label="组件名称" :rules="[v => !!v || '组件名称为必输项']" ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row align="center">
                        <v-col cols="6">
                          <v-text-field  v-model="addData.sort" label="排序序号" :rules="[v => !!v || '排序序号为必输项']" ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="dialog.add = false">关闭</v-btn>
                  <v-btn color="blue darken-1" :loading="loading.addRequest" :disabled="!formValid.add" text
                         @click="addCommit">提交
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.actions="{ item }">
          <!--<v-icon-->
          <!--small-->
          <!--class="mr-4"-->
          <!--@click="editItem(item)"-->
          <!--&gt;-->
          <!--mdi-pencil-->
          <!--</v-icon>-->
          <v-icon
            small
            @click="handleDelete(item)"
          >
            delete
          </v-icon>
          <v-icon
            small
            class="ml-2"
            @click="handleUpdate(item)"
          >
            build
          </v-icon>


        </template>


      </v-data-table>
    </v-row>

    <v-dialog
      v-model="dialog.delete"
      width="300"
    >
      <v-card>
        <v-card-title>
          <span >请确认是否删除</span>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog.delete = false">取消</v-btn>
          <v-btn
            color="error"
            text
            @click="deleteCommit"
          >
            删除
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog.update"
      width="400"
    >
      <v-card>
        <v-card-title>
          <span >菜单更新</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-form ref="updateForm" v-model="formValid.update" >

              <v-row align="center">
                <v-col cols="6">
                  <v-text-field  v-model="updateData.menuName" label="菜单名称" :rules="[v => !!v || '菜单名称为必输项']" ></v-text-field>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="6">
                  <v-text-field  v-model="updateData.path" label="路径" :rules="[v => !!v || '路径为必输项']" ></v-text-field>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="6">
                  <v-text-field  v-model="updateData.component" label="组件名称" :rules="[v => !!v || '组件名称为必输项']" ></v-text-field>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="6">
                  <v-text-field  v-model="updateData.sort" label="排序序号" :rules="[v => !!v || '排序序号为必输项']" ></v-text-field>
                </v-col>
              </v-row>

            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog.update = false">取消</v-btn>
          <v-btn
            text
            @click="updateCommit"
            :loading="loading.update"
            :disable="!formValid.update"
          >
            提交
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <z-notify ref="notify" ></z-notify>

  </v-content>
</template>

<script>
  import {queryRequest, addRequest, deleteRequest, updateRequest} from '@/api/menu'

  export default {
    name: "RoleManagement",
    data() {
      return {
        dialog:{
          add: false,
          update: false,
          delete: false,
          menuBind:false,
        },
        loading: {
          queryRequest: false,
          addRequest: false,
          deleteRequest: false,
          menuBindRequest: false
        },
        formValid: {
          add: false,
          update: false
        },
        dataTable:{
          total: 0,
          list: [],
          options: {},
          headers: [
            {text: '菜单名称', value: 'menuName', sortable: false},
            {text: '路径', value: 'path', sortable: false},
            {text: '组件名称', value: 'component'},
            {text: '排序序号', value: 'sort'},
            {text: '操作', value: 'actions', sortable: false},
          ],
        },
        queryData: {
          menuName: '',
          path: '',
          component: '',
          sortInfo: {
            sortBy: [],
            sortDesc: []
          },
          pagedQueryInfo: {
            index: 1,
            pageSize: 10
          }
        },
        addData: {
          menuName: '',
          path: '',
          component: '',
          sort:'',
        },
        updateData: {
          menuName: '',
          path: '',
          component: '',
          sort:'',
        },
        deleteData:{},
      }
    },
    watch: {
      'dataTable.options': {
        handler(val) {
          this.queryData.pagedQueryInfo.index = val.page
          this.queryData.pagedQueryInfo.pageSize = val.itemsPerPage
          this.queryData.sortInfo.sortBy = val.sortBy
          this.queryData.sortInfo.sortDesc = val.sortDesc
          this.handleQuery()
        }
      }
    },
    methods: {
      handleQuery() {
        this.loading.queryRequest = true
        queryRequest(this.queryData).then(res => {
          this.dataTable.list = res.list
          this.dataTable.total = res.total
          this.loading.queryRequest = false
        }).catch(err => {
          this.loading.queryRequest = false
        })
      },
      resetQuery() {
        this.$refs.queryForm.reset()
      },
      handleDelete(item ) {
        this.deleteData = item
        this.dialog.delete = true
      },
      addCommit() {
        if(this.formValid.add){
          this.loading.addRequest = true
          addRequest(this.addData).then(res => {
            this.loading.addRequest = false
            this.dialog.add = false
            this.handleQuery()
            this.$refs.notify.show("添加成功",{timeout:1000})
          }).catch(err => {
            console.error(err)
          })
        }

      },
      deleteCommit(){
        this.dialog.delete = false
        deleteRequest(this.deleteData.id).then(res => {
          this.$refs.notify.show("删除成功",{timeout:1000})
          this.handleQuery()
        }).catch(err => {
          console.error(err)
        })
      },
      handleUpdate(item){
        this.updateData = item
        this.dialog.update = true
      },
      updateCommit(){
        this.loading.update = true
        updateRequest(this.updateData).then(res => {
          this.loading.update = false
          this.$refs.notify.show("更新成功",{timeout:1000})
          this.dialog.update = false
          this.handleQuery()
        }).catch(err => {
          console.error(err)
          this.loading.update = false
        })
      }
    }
  }
</script>

<style scoped>

</style>